import { render, staticRenderFns } from "./m13.vue?vue&type=template&id=77550477&scoped=true"
import script from "./m13.vue?vue&type=script&lang=js"
export * from "./m13.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77550477",
  null
  
)

export default component.exports